import axios from "axios";
import * as todoTypes from "../../types/user/todoTypes";
import moment from "moment";

export const userCompleteTodoAction =
  (companyId, date) => async (dispatch, getState) => {
    try {
      dispatch({
        type: todoTypes.USER_TODO_COMPLETED_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        date: moment(date).format("YYYY-MM-DD"),
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/todo/${companyId}/all/completed/date`,
        body,
        config
      );
      dispatch({
        type: todoTypes.USER_TODO_COMPLETED_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: todoTypes.USER_TODO_COMPLETED_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userDeleteTodoAction =
  (companyId, todoId) => async (dispatch, getState) => {
    // console.log({ todoId });
    try {
      dispatch({
        type: todoTypes.USER_TODO_DELETE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/todo/${companyId}/${todoId}/complete/delete/one`,
        config
      );
      dispatch({
        type: todoTypes.USER_TODO_DELETE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: todoTypes.USER_TODO_DELETE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userTodayTodoAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: todoTypes.USER_TODO_TODAY_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        date: moment(new Date()).format("YYYY-MM-DD"),
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/todo/${companyId}/date`,
        body,
        config
      );
      dispatch({
        type: todoTypes.USER_TODO_TODAY_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: todoTypes.USER_TODO_TODAY_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userPrevCompleteTodoAction =
  (companyId, date) => async (dispatch, getState) => {
    try {
      dispatch({
        type: todoTypes.USER_PREV_TODO_COMPLETED_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      // console.log(companyId);
      const body = {
        date: moment(date).subtract(1, "days").format("YYYY-MM-DD"),
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/todo/${companyId}/all/completed/date`,
        body,
        config
      );
      dispatch({
        type: todoTypes.USER_PREV_TODO_COMPLETED_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: todoTypes.USER_PREV_TODO_COMPLETED_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userCompleteTimeTodoAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: todoTypes.USER_TODO_COMPLETED_TIME_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/todotime/${companyId}/all/completed/`,
        config
      );
      dispatch({
        type: todoTypes.USER_TODO_COMPLETED_TIME_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: todoTypes.USER_TODO_COMPLETED_TIME_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userNotCompleteTodoAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: todoTypes.USER_TODO_INCOMPLETE_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/todo/${companyId}/incomplete/all`,
        config
      );
      // console.log(data?.data);

      dispatch({
        type: todoTypes.USER_TODO_INCOMPLETE_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: todoTypes.USER_TODO_INCOMPLETE_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userTotalCompleteTodoAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: todoTypes.USER_TODO_TOTAL_COMPLETED_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/todo/${companyId}/total/complete`,
        config
      );
      // console.log(data?.data);

      dispatch({
        type: todoTypes.USER_TODO_TOTAL_COMPLETED_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: todoTypes.USER_TODO_TOTAL_COMPLETED_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userTotalTodoAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: todoTypes.USER_TODO_TOTAL_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/todo/${companyId}/total/`,
        config
      );
      // console.log(data?.data);

      dispatch({
        type: todoTypes.USER_TODO_TOTAL_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: todoTypes.USER_TODO_TOTAL_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userMonthTodoTimeAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: todoTypes.USER_TODO_TIME_MONTH_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const body = {
        month: `${moment(new Date()).format("M")}`,
        year: `${moment(new Date()).format("YYYY")}`,
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/todotime/${companyId}/all/month`,
        body,
        config
      );
      // console.log(data?.data);
      dispatch({
        type: todoTypes.USER_TODO_TIME_MONTH_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: todoTypes.USER_TODO_TIME_MONTH_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userAddTodoTimeAction =
  (companyId, formdata, todoId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: todoTypes.USER_ADD_TODO_TIME_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      // console.log({ companyId, formdata, todoId });
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/todotime/${companyId}/${todoId}`,
        formdata,
        config
      );
      // console.log(data?.data);
      dispatch({
        type: todoTypes.USER_ADD_TODO_TIME_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: todoTypes.USER_ADD_TODO_TIME_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
